export default function CsWebApplications() {
  return (
    <h2>Cs Web Applications</h2>
  );
}
